import React, { Component } from "react";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import Paging from "../../../components/Paging";
import { SCHEDULE_LIST, SCHEDULE_UPDATE_STATUS } from "../endpoints";
import CustomModal from "../CustomModal";
import { NavLink } from "react-router-dom";

class Lists extends Component {
	constructor(props) {
		super(props);

		this.state = {
			dataListAnswer: [],
			dataSiswa: [],
			pageCount: 0,
			currentPage: 0,
			isLoading: false,
			isModalShow: false,
			modalShow:false,
			answer_correction_text:"",
			answer_score:"",
			answer_id:"",
			isButtonLoading: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

	    
	}

	handleChange(event, a) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;
		
		this.setState({
			[name]: value,
			answer_id:a
		});
	}

	handlePageClick(data) {
		let selected = data.selected; // zero based index

		this.setState({ currentPage: selected }, () => {
			this.loadData();
		});
	}

	loadData() {
		this.setState({ isLoading: true });

		const params = qs.stringify({
			page: this.state.currentPage + 1,
			locale:"id",
			platform:"web",
			entry_id:this.props.match.params.entry_id,
			user_id:localStorage.SISMART_USER_ID
		});

		axios({
			method: "post",
			url: "exam/participant-list-answer?" + params
		})

		.then(response => {
			const result = response.data;
			console.log(result)
			if (result.status === true) {
				this.setState({
					dataSiswa: result.data.siswa,
					dataListAnswer: result.data.type,
					pageCount: result.data.last_page,
					isLoading: false
				});
			} else {
				Alert.error(result.text);
				this.setState({ isLoading: false });
			}
		})
		.catch(error => {
			console.log(error);
			this.setState({ isLoading: false });
			Alert.error("Gagal terhubung ke server!");
		});
	}

	handleSubmit() {
		this.setState({ isButtonLoading: true });

		const url = '/exam/correction-answer-essay';

		let newState = {
			locale:"id",
			platform:"web",
			user_id:localStorage.SISMART_USER_ID,
			answer_id: this.state.answer_id,
			answer_score: this.state.answer_score,
			answer_correction_text: this.state.answer_correction_text
		};

		axios({
			method: "post",
			url: url,
			data: qs.stringify(newState)
		})

		.then(response => {
			const result = response.data;

			if (result.status) {
				Alert.success(result.text);
				this.setState({ isButtonLoading: false });
				window.location.reload()
			} else {
				if (Array.isArray(result.text)) {
					result.text.map(item => {
						Alert.error(item);

						return true;
					});
				} else {
					Alert.error(result.text);
				}

				this.setState({ isButtonLoading: false });
			}
		})
		
		.catch(error => {
			console.log(error);
			this.setState({ isButtonLoading: false });
			Alert.error("Gagal terhubung ke server!");
		});
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<div>
				<div className="card-header">
					<div Class="card-body">
						<table className="table table-striped table-bordered animated fadeIn">
							<tr>
								<td>Nama Siswa </td>
								<td>{this.state.dataSiswa.user_nama}</td>
							</tr>
							<tr>
								<td>Nisn </td>
								<td>{this.state.dataSiswa.siswa_nis}</td>
							</tr>
						</table>
					</div>
				</div>
				<div className="card">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : this.state.dataListAnswer.length === 0 ? (
							"Data Kosong..."
						) : (
							<div>
								<table className="table table-striped table-bordered animated fadeIn">
										{this.state.dataListAnswer.map((item, i) => {
											return (
													<tbody>
													<tr>
														<th colspan={3}>{item.question_type.toLocaleUpperCase()}</th>
													</tr>
													<tr>
														<td colspan={3}>
															<div className="card-block">
																{item.question.length === 0 ? (
																	"Data Kosong..."
																) : (
																	<div>
																		<table className="table table-striped table-bordered animated fadeIn">
																			<thead>
																				<tr>
																					<th width={25}>No</th>
																					<th>Pertanyaan</th>
																					<th width={500}>Status Jawaban</th>
																					<th width={200}>Koreksi</th>
																				</tr>
																			</thead>
																			<tbody>
																				{item.question.map((itemQues, i) => {
																					return (
																						<tr key={itemQues.question_id}>
																							<td>{i + 1}</td>
																							<td>
																								
																								{itemQues.question_text}

																								<p style={{ marginBottom: 5 }} />
																								{itemQues.question_type == 'essay' ? (
																									"Essay..."
																								) : (
																									itemQues.question_type == 'match' ? (
																										itemQues.option.map((itemx, i) => (
																											<div
																												className="checkbox"
																												key={`pilihanGanda-${itemx.question_id}-${i}`}
																											>
																												<input
																													type="checkbox"
																													value="option1"
																													checked={itemx.score != null}
																													style={{ marginRight: 5 }}
																													disabled
																												/>
																												{itemx.option_text+" "} 
																												<i className="fa fa-arrows-h fa-lg mt-4"></i>
																												{" "+itemx.option_match_text}
																											</div>
																										))
																									) : (
																										itemQues.option.map((itemx, i) => (
																											<div
																												className="radio"
																												key={`pilihanGanda-${itemx.question_id}-${i}`}
																											>
																												<input
																													type="radio"
																													value="option1"
																													checked={itemx.score != null}
																													style={{ marginRight: 5 }}
																													disabled
																												/>
																												{itemx.student_answer ? <b>{itemx.option_text} (SIswa)</b> : itemx.option_text}
																											</div>
																										))
																									)
																								)
																								}
																							</td>
																							<td>
																							<p style={{ marginBottom: 5 }} />
																								{	itemQues.question_type == 'essay' ? (
																									<div>
																									<p>{itemQues.answer.answer_text}</p>
																									<textarea
																										label="Koreksi Essay"
																										name="answer_correction_text"
																										className="form-control"
																										placeholder="Ketik jawaban yang benar disini ..."
																										onChange={this.handleChange}
																										value={this.state.answer_correction_text !== "" ? this.state.answer_correction_text : itemQues.answer.answer_correction_text}
																										style={{ marginBottom: 10 }}
																									/>
																									Maksimal Nilai {itemQues.total_score}
																									<br>
																									</br>
																									<input
																										type="hidden"
																										name="answer_id"
																										value={itemQues.answer.answer_id}
																									/>
																									<input
																										type="number"
																										name="answer_score"
																										placeholder="Nilai.."
																										max={itemQues.total_score}
																										style={{
																											padding: "3px 7px",
																											border: "1px solid #ccc",
																											width: "20%",
																											marginBottom: "10"
																										}}
																										value={this.state.answer_score !== "" ? this.state.answer_score : itemQues.answer.answer_score}
																										onChange={(event) => this.handleChange(event, itemQues.answer.answer_id)}
																									/>
																									<br>
																									</br>
																									<button
																										type="button"
																										className="btn btn-md btn-primary"
																										disabled={this.state.isButtonLoading && "disabled"}
																										onClick={this.handleSubmit}
																									>
																										{this.state.isButtonLoading ? "Loading" : "Simpan"}
																									</button>
																									</div>
																								) : (
																									itemQues.question_type == 'match' ? (
																										<button 
																											type="button" className={`btn btn-sm ${itemQues.total_score_student > '0'  ? "btn-primary" : "btn-danger" }`}>
																											{itemQues.total_score_student > '0'  ? "Benar " : "Salah "}
																										</button>
																									) : (
																										<button 
																											type="button" className={`btn btn-sm ${itemQues.total_score_student > '0'  ? "btn-primary" : "btn-danger" }`}>
																											{itemQues.total_score_student > '0'  ? "Benar " : "Salah "}
																										</button>
																									)
																								)
																								}
																							</td>
																							<td>
																								{itemQues.question_type == 'essay' ? (
																									<button 
																										type="button" className="btn btn-sm btn-primary">
																										{itemQues.total_score_student} Point
																									</button>
																								) : (
																									itemQues.question_type == 'match' ? (
																										<button 
																											type="button" className={`btn btn-sm ${itemQues.total_score_student > '0'  ? "btn-primary" : "btn-danger" }`}>
																											{itemQues.total_score_student} Point
																										</button>
																									) : (
																										<button 
																											type="button" className={`btn btn-sm ${itemQues.total_score_student > '0'  ? "btn-primary" : "btn-danger" }`}>
																											{itemQues.total_score_student} Point
																										</button>
																									)
																								)
																								}
																							</td>
																						</tr>
																					);
																				})}
																			</tbody>
																		</table>
																	</div>
																)}
															</div>
														</td>
													</tr>
													</tbody>
												)
											}
										)
									}
								</table>
								<Paging
									handlePageClick={this.handlePageClick.bind(this)}
									pageCount={this.state.pageCount}
									currentPage={this.state.currentPage}
								/>
							</div>
						)}
					</div>
				
			</div>
		);
	}
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Exam/Score/Forms.js